module.exports = __webpack_public_path__ + "static/media/img-5.64343e2b.png";